export default __webpack_public_path__ + "static/media/static-delivery.b2e5ce8f.svg";